import { createContext, useContext, type ReactNode } from 'react';
import { useAuth, type AuthState } from './hooks';

const Ctx = createContext<AuthState | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const state = useAuth();
  if (state.loading) {
    return (
      <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span className="spinner" aria-label="Loading session" />
      </div>
    );
  }
  return <Ctx.Provider value={state}>{children}</Ctx.Provider>;
}

export function useAuthCtx(): AuthState {
  const v = useContext(Ctx);
  if (!v) throw new Error('useAuthCtx must be used inside <AuthProvider>');
  return v;
}
